var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "li" }, [
    _c("i", { staticClass: "myIcon iconfont", class: _vm.icon }),
    _vm._v(" " + _vm._s(_vm.name) + " "),
    _c("i", {
      staticClass: "delete iconfont icon-close",
      attrs: { title: "删除" },
      on: {
        click: function ($event) {
          return _vm.deleteNode(_vm.li)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }